import { useEffect, useCallback } from "react";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { useSelector } from "react-redux";
import { getDashboardToken } from "@common/src/service/cloud/dashboard";
import Timer from "@common/src/common/Datepicker/Timer";

const supersetUrl = import.meta.env.VITE_SUPERSET_DASHBOARD_URL
const dashboardId = import.meta.env.VITE_SUPERSET_DASHBOARD_ID

const Crm = () => {
  const { selectedStore, countryStores = {} } = useSelector(
    (state) => state.auth || {}
  );
  const allStores = countryStores.stores
    ?.map((s) => s.outletCode)
    .filter(Boolean)
    .join(",");

  /**
   * MUST return guest token string
   */
  const fetchGuestToken = useCallback(async () => {
    const res = await getDashboardToken({
      dashboardId,
      storeId:  selectedStore?.value || []
    });
    return res.token;
  }, []);
  useEffect(() => {
    const mount = document.getElementById("superset-container");
    if (!mount) return;
    embedDashboard({
      id: dashboardId,
      supersetDomain: supersetUrl,
      mountPoint: mount,
      fetchGuestToken,
      dashboardUiConfig: {
        showDrill: false,
        filters: {
          expanded: false,
        },
        urlParams: {
          outlet_codes:
            selectedStore?.outletCode?.toString() || allStores?.toString(),
        },
      },
    });
  }, [fetchGuestToken, selectedStore, allStores]);

  return (
    <>
      <Timer minutes={5} />
      <div
        id="superset-container"
        className="dash-analytics w-full h-screen overflow-hidden"
      />
      </>
  );
};

export default Crm;
